import { createGlobalStyle, css } from "styled-components";
import "normalize.css";
import "system-font-css";

import HeeboBlack from "../../asserts/fonts/Heebo/static/Heebo-Black.ttf";
import HeeboRegular from "../../asserts/fonts/Heebo/static/Heebo-Regular.ttf";
import HeeboMedium from "../../asserts/fonts/Heebo/static/Heebo-Medium.ttf";
import HeeboSemiBold from "../../asserts/fonts/Heebo/static/Heebo-SemiBold.ttf";
import HeeboExtraBold from "../../asserts/fonts/Heebo/static/Heebo-ExtraBold.ttf";

const globalStyles = css`
  @font-face {
    font-family: Heebo;
    font-weight: 400; /*(regular)*/
    font-display: swap;
    src: url(${HeeboRegular});
  }

  @font-face {
    font-family: Heebo;
    font-weight: 600; /*(Medium)*/
    font-display: swap;
    src: url(${HeeboMedium});
  }

  @font-face {
    font-family: Heebo;
    font-weight: 700; /*(Bold)*/
    font-display: swap;
    src: url(${HeeboSemiBold});
  }

  @font-face {
    font-family: Heebo;
    font-weight: 800; /*(ExtraBold)*/
    font-display: swap;
    src: url(${HeeboExtraBold});
  }
  @font-face {
    font-family: Heebo;
    font-weight: 900; /*(Black)*/
    font-display: swap;
    src: url(${HeeboBlack});
  }

  html {
    box-sizing: border-box;
    font-size: calc(14px + 0.25vw);
    font-family: Heebo, sans-serif;
    width: 100vw;
    /* On iOS 100vh is taller than the visible screen (it includes the browser toolbars),
       which lets the page scroll; dvh is the visible height. vh is the fallback for old browsers */
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    scrollbar-color: transparent;
    scrollbar-width: thin;
    padding: 0;
    margin: 0;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  body {
    width: 100%;
    height: 100%;
    font-family: Heebo, sans-serif;
    min-height: 100vh;
    min-height: 100dvh;
    scrollbar-color: transparent;
    padding: 0;
    margin: 0;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  /* WebKit and Chromiums */
  ::-webkit-scrollbar {
    background-color: transparent;
    border-radius: 5px;
    scrollbar-width: thin;
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
    scrollbar-width: thin;
    width: 8px;
    height: 8px;
  }

  /* Visible scrollbar thumb for mouse users (desktop); touch devices keep overlay scrollbars */
  @media (hover: hover) and (pointer: fine) {
    html,
    body {
      scrollbar-color: #c1c1c1 transparent;
    }
    ::-webkit-scrollbar-thumb {
      background: #c1c1c1;
    }
  }

  .MuiPickersDateRangePickerInput-root {
    align-items: center !important;
  }

  .MuiTypography-root {
    font-size: 16px;
    font-family: Heebo, sans-serif !important;
    margin-inline-start: 10px;
  }

  .MuiPopover-paper {
    max-height: 200px !important;
  }

  .MuiTabPanel-root {
    padding: 0 !important;
  }

  body[dir="rtl"] {
    direction: rtl;
    .MuiSelect-icon {
      right: auto;
    }
  }
  body[dir="ltr"] {
    direction: ltr;
    .MuiSelect-icon {
      left: auto;
    }
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
    outline: none;
  }

  *:focus {
    outline: none;
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  /* Keyboard focus indicator; :focus-visible keeps it hidden on mouse and touch.
     Text fields are left out: browsers treat every click into them as focus-visible,
     and they already show focus with a caret inside their bordered box */
  *:focus-visible:not(input):not(textarea):not(select):not([contenteditable="true"]),
  input[type="checkbox"]:focus-visible,
  input[type="radio"]:focus-visible {
    outline: 2px solid #1655b9;
    outline-offset: 2px;
  }

  /* Pinch-zoom is allowed, so iOS would auto-zoom into any focused field under 16px */
  @media (max-width: 798px) {
    input,
    textarea,
    select,
    .ql-editor {
      font-size: 16px !important;
    }
  }

  a {
    text-decoration: none;
    color: #2460c3;
    &:hover {
      border-bottom: 1px solid #4373c3;
    }
  }

  .MuiInputBase-input-MuiOutlinedInput-input {
    line-height: 1em !important;
  }
  .input {
    line-height: 1em !important;
  }

  .modal {
    background-color: red;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .ql_xxx {
    color: #fff;
    border-radius: 25px;
    margin: 0 5px;
    padding: 5px 15px;
    background-color: #3b67ad;
    white-space: nowrap;
  }
`;

const GlobalStyles = createGlobalStyle`${globalStyles}`;
GlobalStyles.css = globalStyles;

export default GlobalStyles;
